class MobileInlineVariantSelector {
  constructor() {
    this.init();
  }

  init() {
    document.addEventListener('DOMContentLoaded', () => {
      this.root = document.querySelector('.rocket-mobile-purchase');
      if (!this.root) return;

      this.hasDrawer = this.root.classList.contains('rocket-mobile-purchase--has-drawer');
      this.drawer = this.root.querySelector('.rocket-mobile-size-drawer');
      this.opener = this.root.querySelector('.rocket-mobile-purchase__opener');
      this.drawerSubmit = this.root.querySelector('.rocket-mobile-drawer__submit');
      this.addToCartButton = this.hasDrawer
        ? this.drawerSubmit
        : this.root.querySelector('.product-form-mobile__submit');

      this.variantIdInput = this.root.querySelector('.product-variant-id.sticky-mobile');
      this.selectElement = this.root.querySelector('.product-form__variant-picker');
      this.sizeOptions = this.hasDrawer
        ? this.drawer?.querySelector('.sticky-size-options')
        : this.root.querySelector('.sticky-size-options');
      this.selectTrigger = this.root.querySelector('.sticky-select__trigger');
      this.stickyOption = this.hasDrawer
        ? this.drawer?.querySelectorAll('.sticky-option') ?? []
        : this.root.querySelectorAll('.sticky-option');
      this.variantColor = document.querySelectorAll('.variant-option--color');
      this.body = document.body;

      this.setupEventListeners();
      this.setupDrawerControls();
      this.setupClickOutsideListeners();
      this.updateSizesBasedOnColor();

      if (this.hasDrawer) {
        this.syncDrawerSelectionFromVariantInput();
      }
    });
  }

  setupDrawerControls() {
    if (!this.hasDrawer || !this.drawer) return;

    this.root.querySelectorAll('[data-close-drawer]').forEach((btn) => {
      btn.addEventListener('click', () => this.closeDrawer());
    });

    if (this.opener) {
      this.opener.addEventListener('click', (e) => {
        e.preventDefault();
        if (this.opener.disabled) return;
        // Sold-out CTA opens size drawer so user can tap "Notify me" per variant
        this.openDrawer();
      });
    }
  }

  openDrawer() {
    if (!this.drawer) return;
    this.root.classList.add('rocket-mobile-purchase--drawer-open');
    this.drawer.setAttribute('aria-hidden', 'false');
    if (this.opener) this.opener.setAttribute('aria-expanded', 'true');
    this.body.classList.add('rocket-mobile-drawer-open');
    this.syncDrawerSelectionFromVariantInput();
  }

  closeDrawer() {
    if (!this.drawer) return;
    this.root.classList.remove('rocket-mobile-purchase--drawer-open');
    this.drawer.setAttribute('aria-hidden', 'true');
    if (this.opener) this.opener.setAttribute('aria-expanded', 'false');
    this.body.classList.remove('rocket-mobile-drawer-open');
  }

  syncDrawerSelectionFromVariantInput() {
    if (!this.hasDrawer || !this.variantIdInput) return;

    const vid = this.variantIdInput.value;
    if (this.stickyOption && this.stickyOption.length) {
      this.stickyOption.forEach((o) => {
        o.classList.toggle('selected', o.getAttribute('value') === vid && !o.classList.contains('disable'));
      });
    }

    const selected = Array.from(this.stickyOption || []).find(
      (o) => o.getAttribute('value') === vid && !o.classList.contains('disable')
    );

    if (!this.drawerSubmit) return;

    if (selected && !selected.classList.contains('sold-out')) {
      this.drawerSubmit.removeAttribute('disabled');
      this.drawerSubmit.dataset.awaitingSize = 'false';
      this.root.classList.remove('rocket-mobile-purchase--awaiting-size');
      this.updateButtonState(selected);
    } else {
      this.drawerSubmit.setAttribute('disabled', '');
      this.drawerSubmit.dataset.awaitingSize = 'true';
      this.root.classList.add('rocket-mobile-purchase--awaiting-size');
    }
  }

  setupEventListeners() {
    if (!this.hasDrawer && this.selectElement) {
      this.selectElement.addEventListener('click', () => {
        this.selectElement.classList.toggle('active');
        if (this.sizeOptions) this.sizeOptions.classList.toggle('active');
        this.body.classList.toggle('select-sizes-active');
      });
    }

    if (this.stickyOption && this.stickyOption.length) {
      this.stickyOption.forEach((option) => {
        option.addEventListener('click', () => this.handleOptionClick(option));
      });
    }

    if (this.variantColor && this.variantColor.length) {
      this.variantColor.forEach((option) => {
        option.addEventListener('click', () => {
          this.updateSizesBasedOnColor();
        });
      });
    }

    if (!this.hasDrawer && this.addToCartButton) {
      this.addToCartButton.addEventListener(
        'click',
        (e) => {
          if (
            this.addToCartButton.classList.contains('not-active') &&
            !this.addToCartButton.disabled &&
            !this.addToCartButton.classList.contains('disabled')
          ) {
            e.preventDefault();
            e.stopPropagation();
            if (this.selectElement && this.sizeOptions) {
              this.selectElement.classList.add('active');
              this.sizeOptions.classList.add('active');
              this.body.classList.add('select-sizes-active');
            }
          }
        },
        true
      );
    }
  }

  handleOptionClick(option) {
    if (option.classList.contains('disable')) return;

    if (option.classList.contains('sold-out')) {
      const notify = option.querySelector('.sticky-option__notify');
      const variantId =
        notify?.getAttribute('data-variant-id') || option.getAttribute('value');
      if (variantId && typeof window.KlaviyoBISOpen === 'function') {
        window.KlaviyoBISOpen(variantId);
      }
      return;
    }

    if (this.stickyOption && this.stickyOption.length) {
      this.stickyOption.forEach((o) => o.classList.remove('selected'));
    }
    option.classList.add('selected');

    const stickyTitle = option.querySelector('.sticky-title');
    if (this.selectTrigger && stickyTitle) {
      if (option.classList.contains('sold-out')) {
        this.selectTrigger.textContent = `${stickyTitle.textContent} - ${option.getAttribute('description')}`;
      } else {
        this.selectTrigger.textContent = stickyTitle.textContent;
      }
    }

    this.updateButtonState(option);

    if (!this.hasDrawer) {
      this.closeDropdowns();
    }

    const productForms = document.querySelectorAll('.product-form-update');
    const valueOfVariant = option.getAttribute('value');
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      if (input) {
        input.value = valueOfVariant;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    const mobileForm = this.variantIdInput?.closest('form');
    if (mobileForm?.id?.endsWith('-mobile-inline')) {
      const desktopFormId = mobileForm.id.replace(/-mobile-inline$/, '');
      const desktopForm = document.getElementById(desktopFormId);
      const desktopInput = desktopForm?.querySelector(
        'input[name="id"].product-variant-id:not(.sticky-mobile)'
      );
      if (desktopInput) {
        desktopInput.value = valueOfVariant;
        desktopInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    const sizePicker = document.getElementById('size-picker');
    if (sizePicker) {
      const optionName = option.getAttribute('option');
      const radio = sizePicker.querySelector(`input[value="${optionName}"]`);
      if (radio) radio.click();
    }

    if (this.hasDrawer && this.drawerSubmit) {
      this.drawerSubmit.removeAttribute('disabled');
      this.drawerSubmit.dataset.awaitingSize = 'false';
      if (this.root) this.root.classList.remove('rocket-mobile-purchase--awaiting-size');
      return;
    }

    if (!option.classList.contains('sold-out') && this.addToCartButton) {
      const form = this.addToCartButton.closest('form');
      if (form) {
        window.requestAnimationFrame(() => {
          form.requestSubmit();
        });
      }
    }
  }

  updateButtonState(option) {
    if (!this.addToCartButton) return;

    if (!this.hasDrawer) {
      this.addToCartButton.classList.remove('not-active');
      if (this.root) {
        this.root.classList.remove('rocket-mobile-purchase--awaiting-size');
      }
    }

    const iconEmailReStock = document.querySelector('.icon-email-restock-mobile');
    if (option.classList.contains('sold-out')) {
      const span = this.addToCartButton.querySelector('span');
      if (span) span.innerText = option.getAttribute('title');
      this.addToCartButton.dataset.coming = 'true';
      if (this.selectElement) this.selectElement.classList.add('sold-out');
      this.addToCartButton.classList.add('disabled');
      if (iconEmailReStock) iconEmailReStock.classList.remove('hidden');
    } else {
      if (this.variantIdInput) this.variantIdInput.value = option.getAttribute('value');
      const span = this.addToCartButton.querySelector('span');
      if (span) span.innerText = option.getAttribute('title');
      this.addToCartButton.dataset.coming = 'false';
      this.addToCartButton.value = option.getAttribute('value');
      if (this.selectElement) this.selectElement.classList.remove('sold-out');
      this.addToCartButton.classList.remove('disabled');
      if (iconEmailReStock) iconEmailReStock.classList.add('hidden');
    }

    if (this.hasDrawer && this.opener && !option.classList.contains('sold-out')) {
      const openerSpan = this.opener.querySelector('span');
      if (openerSpan && window.variantStrings?.addToCart) {
        openerSpan.textContent = window.variantStrings.addToCart;
      }
    }
  }

  setupClickOutsideListeners() {
    document.addEventListener('click', (event) => {
      if (this.hasDrawer) {
        if (!this.root.classList.contains('rocket-mobile-purchase--drawer-open')) return;
        if (event.target.closest('.rocket-mobile-size-drawer__backdrop')) {
          this.closeDrawer();
          return;
        }
        if (event.target.closest('.rocket-mobile-size-drawer__panel')) return;
        if (this.root.contains(event.target)) return;
        this.closeDrawer();
        return;
      }

      if (!this.selectElement || !this.sizeOptions) return;
      if (!this.selectElement.contains(event.target) && !this.sizeOptions.contains(event.target)) {
        this.closeDropdowns();
      }
    });
  }

  closeDropdowns() {
    if (!this.selectElement || !this.sizeOptions) return;
    if (this.selectElement.classList.contains('active')) {
      this.selectElement.classList.remove('active');
      this.sizeOptions.classList.remove('active');
      this.body.classList.remove('select-sizes-active');
    }
  }

  updateSizesBasedOnColor() {
    const checked = document.querySelector('.variant-option--color:checked');
    if (!checked || !this.stickyOption || !this.stickyOption.length) return;

    const selectedColorVariantId = checked.value;
    this.stickyOption.forEach((stickyVariant) => {
      stickyVariant.classList.remove('selected');
      const variantColorId = stickyVariant.getAttribute('color_id');
      if (variantColorId !== selectedColorVariantId) {
        stickyVariant.classList.add('disable');
      } else {
        stickyVariant.classList.remove('disable');
      }
    });

    if (this.hasDrawer) {
      this.syncDrawerSelectionFromVariantInput();
    }
  }
}

new MobileInlineVariantSelector();
